"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check whether a string consists of whitespace character(s) only.
 *
 * @param {string} value
 * @return boolean
 */
function ctypeSpace(value) {
    let regExp = /^[ \r\n\t\f\v]+$/;
    return regExp.test(value);
}
exports.ctypeSpace = ctypeSpace;
